import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: { designSystem: () => import('./DesignSystemPage.vue') },
} satisfies FeatureRoutes
